module.exports = __webpack_public_path__ + "img/us old.aefc6809.png";